import { memo } from 'react';
import { COLUMN_TYPE, HIGHLIGHTER_VARIANT } from '../../../../../../constants/generalConstants';
import {
    useCellMetadata,
    useColumnContentType,
    useIsColumnImportCandidate,
    useIsRowImportCandidate,
    useRowContentType,
} from '../../../../../../stores/metadataStore';
import { RowIdType, TableBlockRowCellType, TableModeType } from '../../../../../../types';
import { getAnnotationTableCellStyling } from './utils';
import { ImageHighlighterWrapper } from '../../../../../imageHighlighter/imageHighlighter';
import ImagePopup from '../../../../../imagePopup';
import CellDataContainer from '../cellDataContainer';
import { useRowBoundingBox } from '../../../../../../stores/boundingBoxesStore';

type AnnotationsTableCellPropsType = {
    cell: TableBlockRowCellType;
    mode: TableModeType;
    rowId: RowIdType;
};
const AnnotationsTableCell = memo(function AnnotationsTableCell({ cell, mode, rowId }: AnnotationsTableCellPropsType) {
    const colContentType = useColumnContentType(cell.collId)!;
    const rowContentType = useRowContentType(rowId)!;
    const cellMetadata = useCellMetadata(cell.id);
    const isRowImportCandidate = useIsRowImportCandidate(rowId);
    const isColumnImportCandidate = useIsColumnImportCandidate(cell.collId);
    const rowBoundingBox = useRowBoundingBox(rowId);

    const importCandidate = !!isRowImportCandidate && !!isColumnImportCandidate;
    const { styles, classes } = getAnnotationTableCellStyling(
        mode,
        cell,
        rowContentType,
        cellMetadata,
        importCandidate,
        colContentType
    );
    const cellValue = cell.data.value;
    return (
        <td key={cell.id} style={styles} className={classes}>
            <ImageHighlighterWrapper
                coordinates={[
                    { ...rowBoundingBox, variant: HIGHLIGHTER_VARIANT.PRIMARY },
                    { ...cell.boundingBox, variant: HIGHLIGHTER_VARIANT.SECONDARY },
                ]}
            >
                <CellDataContainer>
                    {colContentType !== COLUMN_TYPE.FIELD_NAMES ? (
                        <ImagePopup
                            coordinates={cell.boundingBox}
                            trigger={<span className={'ml-auto'}>{cellValue}</span>}
                        />
                    ) : (
                        <span>{cellValue}</span>
                    )}
                </CellDataContainer>
            </ImageHighlighterWrapper>
        </td>
    );
});

export default AnnotationsTableCell;
